import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var BarGraphVerticalIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M3 2a1 1 0 011 1v16.5h17a1 1 0 010 2H3a1 1 0 01-1-1V3a1 1 0 011-1zm4 7.5a1 1 0 01.993.883L8 10.5v7a1 1 0 01-1.993.117L6 17.5v-7a1 1 0 011-1zm4-4a1 1 0 01.993.883L12 6.5v11a1 1 0 01-1.993.117L10 17.5v-11a1 1 0 011-1zm4 2a1 1 0 01.993.883L16 8.5v9a1 1 0 01-1.993.117L14 17.5v-9a1 1 0 011-1zm4-5a1 1 0 01.993.883L20 3.5v14a1 1 0 01-1.993.117L18 17.5v-14a1 1 0 011-1z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
BarGraphVerticalIcon.isCarinaIcon = true;
export default BarGraphVerticalIcon;
